import { ApiKey } from "./ApiKey.model";
import { Certificate } from "./Certificate.model";
import { Domain } from "./Domain.model";
import { Asana, Azure, Clickup, Github, Integration, Jira, Slack, Trello, Youtrack, Zapier } from "./integrations";
import { Linear } from "./integrations/Linear.model";
import { Notion } from "./integrations/Notion.model";
import { Webhook } from "./integrations/Webhook.model";
import { Platform } from "./Platform.model";

export interface App {
  created: string;
  updated: string;
  id: string;
  bundle_id: string;
  domains: Array<Domain>;
  team_id: string;
  name: string;
  title: string;
  description: string;
  key: string;
  platform: Platform;
  api_keys: Array<ApiKey>;
  jira?: Jira;
  slack?: Slack;
  youtrack?: Youtrack;
  azure?: Azure;
  github?: Github;
  asana?: Asana;
  clickup?: Clickup;
  linear?: Linear;
  notion?: Notion;
  zapier?: Zapier;
  trello?: Trello;
  notify_me: boolean;
  follow_app?: boolean;
  integrations: Array<Integration>;
  has_issue: boolean;
  has_crash: boolean;
  has_app_user: boolean;
  is_approved: boolean;
  is_sample: boolean;
  active: boolean;
  certificate: Certificate;
  logo_url?: string;
  webhook?: Webhook;
  is_extension: boolean;
  ai_enabled: boolean;
}

export interface BasicAppNotificationSettings {
  id: string;
  name: string;
  follow_app: boolean;
  logo_url?: string | null;
}

export const mapAppToBasicNotificationSettings = (app: App): BasicAppNotificationSettings => {
  return { id: app.id, name: app.name, follow_app: !!app.follow_app, logo_url: app.logo_url };
};
